module.exports = __webpack_public_path__ + "static/media/silverguard.da11c5de.svg";